import { Row } from "antd";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";

import { HeaderSection, LogoContainer } from "./styles";
import { styled } from "@mui/system";

import { Box, Button, Typography, CircularProgress } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useNavigate } from "react-router-dom";
import { getCurrentUser, logout } from "../../service/authService";
import { useEffect, useState } from "react";
import { useApi } from "../../store/UserLoginContext";
import InsertInvitationRoundedIcon from "@mui/icons-material/InsertInvitationRounded";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { useMediaQuery, useTheme } from "@mui/material";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  // border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  margin: "1rem",
  marginRight: "0rem",
  "&:hover": {
    color: "#fff",
    border: "0.2px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const MyCustomHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true for screens <600px
  const navigate = useNavigate();
  const user = getCurrentUser();

  const { currentSessionAY } = useApi();
  const [loading, setLoading] = useState<boolean>(false);

  const logoutHandler = () => {
    try {
      setLoading(true);
      logout();
      setTimeout(() => {
        setLoading(false);
        navigate("/login");
        window.location.reload();
      }, 300);
    } catch (error) {
      console.log("Some error while logout");
    }
  };

  return (
    <>
      <HeaderSection>
        <Container>
          <Box
            display="flex"
            flexDirection="column"
            width="100%"
            mt={{ xs: 2 }}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
            >
              <Box ml={1}>
                <SvgIcon
                  src="updated_productLogo1.svg"
                  width={isMobile ? "200" : "300px"}
                  height={isMobile ? "40px" : "50px"}
                  marginLeft={isMobile ? "-2.5rem" : "-5rem"}
                />
              </Box>

              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                gap={1}
              >
                {user && (
                  <>
                    <Box textAlign="center" mt={1}>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        color="#2E186A"
                        fontSize={isMobile ? 10 : 20}
                        mt={isMobile ? 0.2 : 0}
                      >
                        {isMobile
                          ? `${user?.name || user?.username || "User"}`
                          : `Hello ${user?.name || user?.username || "User"}`}
                      </Typography>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"center"}
                        gap={1}
                        alignItems={"center"}
                      >
                        {!isMobile && (
                          <InsertInvitationRoundedIcon
                            style={{
                              color: "#cb3d64",
                            }}
                          />
                        )}
                        <Typography
                          variant="caption"
                          color="#cb3d64"
                          fontWeight="bold"
                          fontSize={isMobile ? 11 : ""}
                        >
                          AY {currentSessionAY}
                        </Typography>
                      </Box>
                    </Box>
                    {isMobile ? (
                      <PowerSettingsNewIcon
                        fontSize="large"
                        style={{ color: "#cb3d64", marginTop: 5 }}
                        onClick={logoutHandler}
                      />
                    ) : (
                      <MyCustomButton
                        variant="contained"
                        startIcon={
                          loading ? (
                            <CircularProgress size={20} />
                          ) : (
                            <ExitToAppIcon />
                          )
                        }
                        onClick={logoutHandler}
                        disabled={loading}
                        sx={{
                          alignSelf: "center",
                          height: "30px",
                          width: { xs: "100%", sm: "auto" },
                        }}
                      >
                        Logout
                      </MyCustomButton>
                    )}
                  </>
                )}
              </Box>
            </Box>

            <Box
              width={"100%"}
              height={"5px"}
              ml={-3}
              mt={1}
              sx={{
                background: "linear-gradient(to right, #ff825b, white)",
              }}
            />
          </Box>
        </Container>
      </HeaderSection>
    </>
  );
};

export default MyCustomHeader;
